import React, { useState } from "react";
import {
  LandingHeaderStyle,
  LandingHeaderWrap,
  LandingHeaderList,
  ProductLinks,
  LandingHeaderBtn,
  Flex,
  LandingHeaderItem,
  ImageIcon,
} from "./LandingHeader.style";
import { TripMoneyLogo } from "@tm/static/icons";
import { SpanTag, AnchorTag, ImageComponent } from "@tm/static";
import { theme } from "@tm/utility/global";

const productLinks = [
  "Foreign Currency",
  "Forex Cards",
  "Travel Insurance",
  "Travel Loan",
  "Foreign Money Trasfer",
];

interface LandingHeaderProps {
  loginState?: boolean;
  logoUrl?: string;
}

const LandingHeader = ({ loginState, logoUrl }: LandingHeaderProps) => {
  const [show, setShow] = useState(false);

  const handleClick = () => {
    setShow(!show);
  };

  return (
    <LandingHeaderStyle id="header-id">
      <LandingHeaderWrap id="headerWrap-id">
        <AnchorTag>
          <TripMoneyLogo />
        </AnchorTag>

        {!loginState && (
          <React.Fragment>
            <LandingHeaderList>
              <LandingHeaderItem
                opened={show}
                closed={!show}
                onClick={handleClick}
              >
                <AnchorTag hrefProp="#" aria-label="products">
                  Products
                </AnchorTag>
                {show && (
                  <ProductLinks>
                    {productLinks &&
                      productLinks.map((item, index) => {
                        return (
                          <AnchorTag key={index} hrefProp="#">
                            {item}
                          </AnchorTag>
                        );
                      })}
                  </ProductLinks>
                )}
              </LandingHeaderItem>
              <LandingHeaderItem>
                <AnchorTag hrefProp="#">Blogs</AnchorTag>
              </LandingHeaderItem>
              <LandingHeaderItem>
                <AnchorTag hrefProp="#">FAQ’s</AnchorTag>
              </LandingHeaderItem>
              <LandingHeaderItem>
                <AnchorTag hrefProp="#">About Us</AnchorTag>
              </LandingHeaderItem>
            </LandingHeaderList>
            <LandingHeaderBtn>LOGIN</LandingHeaderBtn>
          </React.Fragment>
        )}
        {loginState && (
          <Flex>
            <ImageIcon>C</ImageIcon>
            <SpanTag fontSize="xxs" color={theme.whiteText} fontWeight="bold">
              Hey Chavi
            </SpanTag>
            <ImageComponent
              width="14px"
              height="14px"
              src="https://tripmoneycmsimgak.mmtcdn.com/img/white_Chev_8257cb46d7.svg"
            />
          </Flex>
        )}
      </LandingHeaderWrap>
    </LandingHeaderStyle>
  );
};

export default LandingHeader;
